import {History} from 'history'

export function navigate(link: string, history: History) {
  if (link.startsWith('http')) {
    window.open(link, '_blank')
  } else if (link.startsWith('mailto:')) {
    window.location.href = link
  } else {
    history.push(link)
  }
}
